import i18n from '@/i18n'

// 支持的语言列表
export const SUPPORTED_LANGUAGES = [
  { value: 'zh-CN', name: '简体中文' },
  { value: 'zh-TW', name: '繁體中文' },
  { value: 'en', name: 'English' },
  { value: 'ja', name: '日本語' },
  { value: 'th', name: 'ไทย' },
  { value: 'es', name: 'Español' }
]

// 设置语言
export function setLanguage(locale) {
  // 保存到 localStorage
  localStorage.setItem('locale', locale)
  // 更新 i18n 实例
  i18n.locale = locale
  // 触发语言变更事件
  window.dispatchEvent(new CustomEvent('language-change', { detail: { locale }}))
}

// 获取当前语言
export function getLanguage() {
  return i18n.locale || localStorage.getItem('locale') || 'zh-CN'
}

// 根据浏览器语言自动选择
export function getBrowserLanguage() {
  const browserLang = navigator.language?.toLowerCase() || 'zh-cn'
  if (browserLang.includes('zh')) {
    return browserLang.includes('tw') || browserLang.includes('hk') ? 'zh-TW' : 'zh-CN'
  }
  if (browserLang.includes('en')) return 'en'
  if (browserLang.includes('ja') || browserLang.includes('jp')) return 'ja'
  if (browserLang.includes('th')) return 'th'
  if (browserLang.includes('es')) return 'en' // 默认用英文
  return 'zh-CN'
}
